import { OrganizationConfig } from '@tenants/types/tenant';
import { EXP_CANADA_ADDRESS, EXP_QUEBEC_ADDRESS } from '@tenants/definitions/shared/addresses';
import { SiteLanguage } from 'types/locales';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber() {
      return '833-303-0610';
    },
    email() {
      return 'info@exprealty.net';
    },
    address(options) {
      // Show Quebec address if locale is fr-CA OR user is from Quebec
      if (options?.locale === SiteLanguage.FrenchCA || options?.isUserInQuebec) {
        return EXP_QUEBEC_ADDRESS;
      }
      return EXP_CANADA_ADDRESS;
    },
    twitterUrl: 'https://twitter.com/exprealtycanada',
    facebookUrl: 'https://www.facebook.com/exprealtycanada',
    instagramUrl: 'https://www.instagram.com/expcanada_?igsh=YmtqZzRqZHR1Z2Yw&utm_source=qr',
    linkedinUrl: 'https://www.linkedin.com/showcase/exprealtycanada',
    youtubeUrl: 'https://www.youtube.com/@eXpRealty',
    joinSectionUrl: 'https://join.exprealty.ca',
  };
}
